module.exports = __webpack_public_path__ + "static/media/18a-04_ST-2018-196x159cm-oleo-sobre-tela.76589d60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18a/18a-04_ST-2018-196x159cm-oleo-sobre-tela.jpg
// module id = 222
// module chunks = 0